import { render, staticRenderFns } from "./ResignAOA.vue?vue&type=template&id=c22231b2"
import script from "./ResignAOA.vue?vue&type=script&lang=js"
export * from "./ResignAOA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports